import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Messages from './Messages';

import s from './HistoryParameters.css';

class HistoryParametersRow extends React.Component {
  getColumnVisibilityByIndex = (
    index,
    documentSoftenerFilter,
    documentSuperiorFilter,
    deviceType,
  ) => {
    let values = [];
    let ret = 0;
    switch (deviceType) {
      case 'charlie':
      case 'softener':
      case 'simplex':
        values = [
          documentSoftenerFilter.get('date'),
          documentSoftenerFilter.get('time'),
          documentSoftenerFilter.get('language'),
          documentSoftenerFilter.get('unit_water_hardness'),
          documentSoftenerFilter.get('water_pressure'),
          documentSoftenerFilter.get('pressure_sensor'),
          documentSoftenerFilter.get('chlorine_generator'),
          documentSoftenerFilter.get('reserve_period'),
          documentSoftenerFilter.get('reg_period'),
          documentSoftenerFilter.get('days_of_regeneration'),
          documentSoftenerFilter.get('outlet_water_hardness'),
          documentSoftenerFilter.get('intlet_water_hardness'),
          documentSoftenerFilter.get('regenerant_dose'),
          documentSoftenerFilter.get('resin_volume'),
          documentSoftenerFilter.get('reserve_type'),
          documentSoftenerFilter.get('percentage_of_reserve'),
          documentSoftenerFilter.get('regeneration_time'),
          documentSoftenerFilter.get('average_water_used'),
          documentSoftenerFilter.get('ferrum_content'),
          documentSoftenerFilter.get('type_of_regeneration'),
          documentSoftenerFilter.get('cancel_vacation_mode'),
          documentSoftenerFilter.get('backwash'),
          documentSoftenerFilter.get('rapid_rinsing'),
          documentSoftenerFilter.get('dhcp_client'),
          documentSoftenerFilter.get('ip_address'),
          documentSoftenerFilter.get('subnet_mask'),
          documentSoftenerFilter.get('default_gateway'),
          documentSoftenerFilter.get('dns_server'),
          documentSoftenerFilter.get('timezone'),
          documentSoftenerFilter.get('device_type'),
        ];
        ret = values[index];
        break;
      case 'superior':
        values = [
          documentSuperiorFilter.get('date'),
          documentSuperiorFilter.get('time'),
          documentSuperiorFilter.get('language'),
          documentSuperiorFilter.get('device_type'),
          documentSuperiorFilter.get('auto_degass_start_1_enable'),
          documentSuperiorFilter.get('auto_degass_start_1_hour'),
          documentSuperiorFilter.get('auto_degass_start_1_minute'),
          documentSuperiorFilter.get('auto_degass_stop_1_enable'),
          documentSuperiorFilter.get('auto_degass_stop_1_hour'),
          documentSuperiorFilter.get('auto_degass_stop_1_minute'),
          documentSuperiorFilter.get('auto_degass_start_2_enable'),
          documentSuperiorFilter.get('auto_degass_start_2_hour'),
          documentSuperiorFilter.get('auto_degass_start_2_minute'),
          documentSuperiorFilter.get('auto_degass_stop_2_enable'),
          documentSuperiorFilter.get('auto_degass_stop_2_hour'),
          documentSuperiorFilter.get('auto_degass_stop_2_minute'),
          documentSuperiorFilter.get('degassblock'),
        ];
        ret = values[index];
        break;
      default:
        break;
    }
    return ret;
  };

  showBox = (element, index, messages, deviceType, intl) => {
    const visible = this.getColumnVisibilityByIndex(
      index,
      this.props.documentSoftenerFilter,
      this.props.documentSuperiorFilter,
      deviceType,
    );
    const value = element.get(0);
    const isChanged = element.get(1);
    let wrappedStyle = cx();
    switch (deviceType) {
      case 'charlie':
      case 'softener':
      case 'simplex':
        wrappedStyle = isChanged 
          ? cx(s.red, s.row_container, s.data_color, s.center)
          : cx(s.row_container, s.data_color, s.center);
        break;
      case 'superior':
        wrappedStyle = isChanged 
          ? cx(s.red, s.row_container, s.spirotech_data_color, s.center)
          : cx(s.row_container, s.spirotech_data_color, s.center);
        break;
      default:
        break;
    }
    if (visible) {
      if (deviceType === 'softener' || deviceType === 'charlie' || deviceType === 'simplex') {
        if (index === 5 || index === 6 || index === 19) {
          return (
            <td className={wrappedStyle} key={index}>
              <button className={s.button} onClick={this.props.onClick}>
                <FormattedMessage {...messages[value]} />
              </button>
            </td>
          );
        } else if (index === 9) {
          let retValue = '';
          if (value !== '') {
            const days = value.split(',');
            for (let i = 0; i < days.length; i += 1) {
              if (retValue === '') {
                retValue += intl.formatMessage({ ...messages[days[i]] });
              } else {
                retValue += `, ${intl.formatMessage({ ...messages[days[i]] })}`;
              }
            }
          }
          return (
            <td className={wrappedStyle} key={index}>
              <button className={s.button} onClick={this.props.onClick}>
                {retValue}
              </button>
            </td>
          );
        }
        return (
          <td className={wrappedStyle} key={index}>
            {value}
          </td>
        );
      } else if (deviceType === 'superior') {
        return (
          <td className={wrappedStyle} key={index}>
            {value}
          </td>
        );
      }
    }
    return null;
  };

  render() {
    const messages = Messages();
    const { row, deviceType, intl } = this.props;
    if (typeof row !== 'undefined') {
      return (
        <tr className={s.row_container}>
          {row.map((element, ind) =>
            this.showBox(element, ind, messages, deviceType, intl),
          )}
        </tr>
      );
    }
    return null;
  }
}

HistoryParametersRow.propTypes = {
  row: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSoftenerFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSuperiorFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  deviceType: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(withStyles(s)(HistoryParametersRow));



// WEBPACK FOOTER //
// ./src/components/HistoryParameters/HistoryParameterRow.js